<template>
  <div id="app" class="container">
    <hw-header></hw-header>
    <div class="row main">
        <div class="col-md-12">
          <h2 class="top_title"><span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span><a href="https://www.helloweba.net/javascript/591.html">基于animate动画库的数字增长动画组件</a></h2>
          <div class="container" style="width: 96%; margin: 30px auto">
              
                <div class="form-inline form-group">
                  <label for="">Value: </label>
                  <input class="form-control" type="number" v-model="value">
                </div>
                <div class="form-inline form-group">
                  <label for="">间隔时间: </label>
                  <input class="form-control" type="number" v-model="duration">
                </div>
                <div class="row" style="margin-top:40px;">
                    <div class="col-md-4 col-xs-12">
                      <animated-number class="animate"
                        :value="value" 
                        :formatValue="formatToPrice" 
                        :duration="duration"
                      ></animated-number>
                      <hr/>
                      <button class="btn btn-info" @click="increase">+500</button>
                      <button class="btn btn-warning" @click="decrease">-500</button>
                    </div>
                    <div class="col-md-4 col-xs-12">
                      <animated-number class="animate" style="background-color:#00a558"
                        :value="2000.34" 
                        :formatValue="formatToPrice" 
                        :duration="3000"
                      ></animated-number>
                    </div>
                    <div class="col-md-4 col-xs-12">
                      <animated-number class="animate" style="background-color:#0571b6"
                        :value="12345.99" 
                        :formatValue="formatToPrice" 
                        :duration="1000"
                      ></animated-number>
                    </div>
                </div>
                

        </div>
    </div>
  </div>
  <hw-footer></hw-footer>
  </div>
</template>

<script>
import './assets/css/demo.css'
import Header from './components/Header'
import Footer from './components/Footer'
import AnimatedNumber from "animated-number-vue";

export default {
  components: {
    HwHeader: Header,
    HwFooter: Footer,
    AnimatedNumber
  },
  data() {
    return {
      value: 1000,
      duration: 1000
    }
  },
  methods: {
    // formatToPrice(value) {
    //   return `$ ${value.toFixed(2)}`;
    // },
    formatToPrice(value) {
      return `$ ${Number(value).toFixed(2)}`;
    },
    increase() {
      this.value = Number(this.value) + 500;
    },
    decrease() {
      this.value = Number(this.value) - 500;
    }
  }
}
</script>

<style>
.animate{
  padding: 20px;
  width: 200px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background-color: #dd4a38;
  box-shadow: 6px 6px 3px #888;
}
</style>



// WEBPACK FOOTER //
// src/App.vue